// MemberTablePopover.js
import { useState } from "react";
import { useDispatch } from "react-redux";
import { alpha } from "@mui/material/styles";
import {
  Divider,
  Stack,
  MenuItem,
  IconButton,
  Popover,
  ListItemIcon,
} from "@mui/material";
import { Icon } from "@iconify/react";
import { setDialog } from "../../../features/dialog/dialogSlice";

const MENU_OPTIONS = [
  { label: "Bearbeiten", icon: "uil:edit", action: "EDIT" },
  { label: "Anzeigen", icon: "bxs:user-detail", action: "SHOW" },
  { label: "Vertrag", icon: "material-symbols:contract", action: "CONTRACT" },
  {
    label: "Kündigen",
    icon: "icon-park-twotone:termination-file",
    action: "TERMINATE",
  },
  { label: "Einfrieren", icon: "ion:snow", action: "FREEZE" },
];

export default function MemberTablePopover({ member }) {
  const [open, setOpen] = useState(null);
  const dispatch = useDispatch();

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleAction = (action) => {
    dispatch(setDialog({ type: "MEMBERACTIONS", data: { action, member } }));
    setOpen(null);
  };

  const handleClose = () => setOpen(null);

  return (
    <>
      <IconButton
        onClick={(e) => {
          e.stopPropagation(); // IMPORTANT: prevent row selection
          handleOpen(e);
        }}
        edge="end"
        color="inherit"
        aria-label="member-edit"
        sx={{
          "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.94)" },
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Icon icon="material-symbols:person-edit" width="24" height="24" />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            "& .MuiMenuItem-root": { typography: "body2", borderRadius: 0.75 },
          },
        }}
      >
        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem
              key={option.label}
              onClick={() => handleAction(option.action)}
            >
              <ListItemIcon>
                <Icon icon={option.icon} width="24" height="24" />
              </ListItemIcon>
              {option.label}
            </MenuItem>
          ))}
        </Stack>
        <Divider sx={{ borderStyle: "dashed" }} />

        <MenuItem
          onClick={() => handleAction("DELETE")}
          sx={{
            m: 1,
            backgroundColor: "rgba(233, 74, 74, 0.85)",
            color: "white",
            "&:hover": {
              backgroundColor: "rgba(238, 26, 26, 0.85)",
              color: "white",
              "& #trash-icon": { color: "white" },
            },
          }}
        >
          <ListItemIcon id="trash-icon">
            <Icon icon={"jam:trash"} width="24" height="24" />
          </ListItemIcon>
          Löschen
        </MenuItem>
      </Popover>
    </>
  );
}
